
import Vue, { PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import { HymnApi } from '~/apiclient/apihymns'
import KeydownEvent from '~/models/generic/KeydownEvent'
import { foundationsHymnUrl, siteHymnUrl } from '~/assets/ts/utils/urls'
import CustomDropdown from '~/components/_general/CustomDropdown.vue'
import SaIcon from '~/components/_general/SaIcon.vue'
import InlineIcon from '~/components/_general/InlineIcon.vue'
import SaLink from '~/components/_general/SaLink.vue'
import KeydownObserver from '~/components/_general/KeydownObserver.vue'

export default Vue.extend({
  name: 'HymnLyrics',
  components: { KeydownObserver, SaLink, InlineIcon, SaIcon, CustomDropdown },
  props: {
    hymn: {
      type: Object as PropType<HymnApi>,
      required: true,
    },
    foundations: {
      type: Boolean,
    },
  },
  data() {
    return {
      textSize: 36,
      maxFontSize: 60,
      minFontSize: 24,
      fontAdjustmentSize: 6,
    }
  },
  computed: {
    isDark(): boolean {
      return this.$colorMode.value === 'dark'
    },
    themeText(): TranslateResult {
      return this.isDark ? this.$t('Light Theme') : this.$t('Dark Theme')
    },
    baseHymnUrl(): string {
      if (this.foundations) {
        return foundationsHymnUrl(this, this.hymn)
      }
      return siteHymnUrl(this.hymn)
    },
  },
  methods: {
    toggleTheme() {
      this.$colorMode.preference = this.isDark ? 'light' : 'dark'
    },
    growText() {
      if (this.textSize < this.maxFontSize) {
        this.textSize += this.fontAdjustmentSize
      }
    },
    shrinkText() {
      if (this.textSize > this.minFontSize) {
        this.textSize -= this.fontAdjustmentSize
      }
    },
    keydown(key: KeydownEvent) {
      if (key.Escape) {
        key.event.preventDefault()
        this.$router.back()
      }
    },
  },
})
